import { SubscriptionOption, RxNotificationType } from '@/lib/types/datatypes';

export const PAGE_TITLE = 'page.title';

export const PREFERENCE_TYPES = {
  TEXTS: 'preference.types.texts',
  AUTOMATED_CALLS: 'preference.types.automatedCalls',
  EMAILS: 'preference.types.emails',
  EMAILS_AND_RECEIPTS: 'preference.types.emailsAndReceipts',
  MAIL: 'preference.types.mail',
  MAIL_AND_PRINT: 'preference.types.mailAndPrint',
};

export const PREFERENCE_UPDATE_SUCCESS = {
  HEADING: 'preference.update.success.heading',
  BODY: 'preference.update.success.body',
};

// Text Communication Page
export const TEXT_COMMUNICATION = {
  PAGE_TITLE: 'page.texts.title',
  RX_TEXT_ALERTS_LABEL: 'texts.pharmacy.label',
  EC_TEXT_ALERTS_LABEL: 'texts.extracare.label',
  CMK_TEXT_ALERTS_LABEL: 'texts.caremark.label',
  SPLTY_TEXT_ALERTS_LABEL: 'texts.specialty.label',
};

// Pharmacy Text Alerts Page
export const PHARMACY_TEXT_ALERTS = {
  PAGE_TITLE: 'pharmacy.texts.title',
  PAGE_SUB_TITLE: 'pharmacy.texts.subtitle',
  MOBILE_FIELD_LABEL: 'pharmacy.texts.mobileLabel',
  MOBILE_FIELD_HELPER: 'pharmacy.texts.mobileHelper',
  RX_TEXT_ENROLLMENT_HEADING: 'pharmacy.texts.enrollmentHeading',
  RX_TEXT_ENROLLMENT_HELPER: 'pharmacy.texts.enrollmentHelper',
  CANCEL: 'button.cancel',
  SAVE: 'button.save',
  DISCLAIMER_TEXT: 'pharmacy.texts.disclaimer',
  SMS_DISCLAIMER_TEXT: 'pharmacy.texts.smsDisclaimer',
};

// Specialty Text Alerts Page
export const SPECIALTY_TEXT_ALERTS = {
  PAGE_TITLE: 'specialty.texts.title',
  PAGE_SUB_TITLE: 'specialty.texts.subtitle',
  MOBILE_FIELD_LABEL: 'specialty.texts.mobileLabel',
  MOBILE_FIELD_HELPER: 'specialty.texts.mobileHelper',
  SPLTY_TEXT_ENROLLMENT_HEADING: 'specialty.texts.enrollmentHeading',
  SPLTY_TEXT_ENROLLMENT_HELPER: 'specialty.texts.enrollmentHelper',
  CANCEL: 'button.cancel',
  SAVE: 'button.save',
};

export const EXTRACARE_TEXT_ALERTS_CARD = {
  PAGE_TITLE: 'extracare.texts.title',
  INFO: 'extracare.texts.info',
  CUSTOMER_CARE_NUMBER: 'extracare.texts.customerCareNumber',
  CUSTOMER_CARE_NUMBER_LINK: 'extracare.texts.customerCareNumberLink',
  ENROLLMENT_MSG: 'extracare.texts.enrollmentMsg',
};

export const EXTRACARE_TEXT_ALERTS = {
  PAGE_TITLE: 'extracare.texts.title',
  PAGE_SUB_TITLE: 'extracare.texts.subtitle',
  MOBILE_FIELD_LABEL: 'extracare.texts.mobileLabel',
  MOBILE_FIELD_HELPER: 'extracare.texts.mobileHelper',
  TEXT_ENROLLMENT_HEADING: 'extracare.texts.enrollmentHeading',
  TEXT_ENROLLMENT_HELPER: 'extracare.texts.enrollmentHelper',
  CANCEL: 'button.cancel',
  SAVE: 'button.save',
};

export const PHARMACY_TEXT_AUTOMATED_CALLS_MODAL = {
  TITLE: 'modal.phoneConflict.heading',
  BODY_P1: 'modal.phoneConflict.bodyP1',
  BODY_P2: 'modal.phoneConflict.bodyP2',
  SUBMIT_BTN_TEXT: 'modal.phoneConflict.submitBtn',
  KEEP_EXISTING_NUMBER_BTN_TEXT: 'modal.phoneConflict.keepExistingBtn',
};

export const PHARMACY_TEXT_ALERTS_UPDATE_ERROR = {
  HEADING: 'error.update.heading',
  BODY: 'error.update.body',
};

export const RX_TEXT_ALERTS_HOW_LABELS = [
  {
    type: RxNotificationType.PRESCRIPTION_AND_MARKETING,
    title: 'subscription.pharmacy.texts.allEnroll.title',
    desc: 'subscription.pharmacy.texts.allEnroll.desc',
  },
  {
    type: RxNotificationType.PRESCRIPTION_ONLY,
    title: 'subscription.pharmacy.texts.prescriptionOnly.title',
    desc: 'subscription.pharmacy.texts.prescriptionOnly.desc',
  },
  {
    type: RxNotificationType.NONE,
    title: 'subscription.pharmacy.texts.none.title',
    desc: 'subscription.pharmacy.texts.none.desc',
  },
];

export const SPECIALTY_TEXTS_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    label: 'subscription.specialty.texts.enroll.label',
    desc: 'subscription.specialty.texts.enroll.desc',
  },
  {
    key: 'OUT',
    label: 'subscription.specialty.texts.noEnroll.label',
    desc: 'subscription.specialty.texts.noEnroll.desc',
  },
];

export const EXTRACARE_TEXTS_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  {
    key: 'Y',
    label: 'subscription.extracare.texts.enroll.label',
    desc: 'subscription.extracare.texts.enroll.desc',
  },
  {
    key: 'O',
    label: 'subscription.extracare.texts.noEnroll.label',
    desc: 'subscription.extracare.texts.noEnroll.desc',
  },
];

interface PhoneType {
  [key: string]: string;
}

export const PHONE_TYPE_USE: PhoneType = {
  Mobile: '1',
  Home: '2',
  Office: '3',
};

export const CMK_PHONE_TYPES = [
  { label: 'phoneType.select' },
  { label: 'phoneType.mobile', value: '5' },
  { label: 'phoneType.other', value: '3' },
];

export const PHONE_NUMBER_VALIDATION = {
  INVALID_NUMBER: 'validation.phone.invalid',
  MAKE_A_SELECTION: 'validation.phone.makeSelection',
};

// Automated Calls Page
export const AUTOMATED_CALLS = {
  PAGE_TITLE: 'page.automatedCalls.title',
  RX_AUTOMATED_CALLS_LABEL: 'calls.pharmacy.label',
  CAREMARK_AUTOMATED_CALLS_LABEL: 'calls.caremark.label',
};

// Pharmacy Calls Page
export const PHARMACY_CALLS = {
  PAGE_TITLE: 'calls.pharmacy.title',
  RX_CALLS_ENROLLMENT_HEADING: 'calls.pharmacy.enrollmentHeading',
};

export const RX_CALLS_HOW_LABELS = [
  {
    type: RxNotificationType.PRESCRIPTION_ONLY,
    title: 'subscription.pharmacy.calls.prescriptionOnly.title',
    desc: 'subscription.pharmacy.calls.prescriptionOnly.desc',
  },
  {
    type: RxNotificationType.PRESCRIPTION_AND_MARKETING,
    title: 'subscription.pharmacy.calls.allEnroll.title',
    desc: 'subscription.pharmacy.calls.allEnroll.desc',
  },
  {
    type: RxNotificationType.NONE,
    title: 'subscription.pharmacy.calls.none.title',
    desc: 'subscription.pharmacy.calls.none.desc',
  },
];

export const EMAILS = {
  PAGE_TITLE: 'page.emails.title',
  CVS: {
    LABEL: 'emails.cvs.label',
  },
  ALERTS: {
    LEGEND_TEXT: 'emails.alerts.legendText',
    HELPER_TEXT: 'emails.alerts.helperText',
  },
  RX: {
    LABEL: 'emails.pharmacy.label',
    PAGE_TITLE: 'pharmacy.emails.title',
    PAGE_SUBTITLE: 'pharmacy.emails.subtitle',
    EMAIL_ADDRESS_LABEL: 'pharmacy.emails.emailLabel',
    EMAIL_FIELD_HELPER: 'pharmacy.emails.emailHelper',
    SUBMIT_BTN_TEXT: 'button.save',
    EMAIL_SUBSCRIPTION_OPTION_HEADING: 'pharmacy.emails.subscriptionHeading',
    EMAIL_SUBSCRIPTION_OPTION_HELPER: 'pharmacy.emails.subscriptionHelper',
  },
  EC: {
    LABEL: 'emails.extracare.label',
    EC_OFFERS_LABEL: 'extracare.emails.title',
    IN_STORE_RECEIPTS_LABEL: 'extracare.emails.instoreReceiptsHeading',
  },
  SPECIALTY: {
    LABEL: 'emails.specialty.label',
    URL: '/communication-preferences/specialty-emails',
    PAGE_TITLE: 'specialty.emails.title',
    PAGE_SUBTITLE: 'specialty.emails.subtitle',
    EMAIL_ADDRESS_LABEL: 'specialty.emails.emailLabel',
    EMAIL_FIELD_HELPER: 'specialty.emails.emailHelper',
    SUBMIT_BTN_TEXT: 'button.save',
    EMAIL_SUBSCRIPTION_OPTION_HEADING: 'specialty.emails.subscriptionHeading',
    EMAIL_SUBSCRIPTION_OPTION_HELPER: 'specialty.emails.subscriptionHelper',
  },
  CAREMARK: {
    LABEL: 'emails.caremark.label',
    PAGE_TITLE: 'caremark.emails.title',
    PAGE_SUBTITLE: 'caremark.emails.subtitle',
    EMAIL_ADDRESS_LABEL: 'caremark.emails.emailLabel',
    EMAIL_FIELD_HELPER: 'caremark.emails.emailHelper',
    SUBMIT_BTN_TEXT: 'button.save',
    EMAIL_SUBSCRIPTION_OPTION_HEADING: 'caremark.emails.subscriptionHeading',
    EMAIL_SUBSCRIPTION_OPTION_HELPER: 'caremark.emails.subscriptionHelper',
    EMAIL_LEGEND_TEXT: 'caremark.emails.legendText',
    EMAIL_HELPER_TEXT: 'caremark.emails.helperText',
  },
};

export const TEXTS = {
  CAREMARK: {
    LABEL: 'texts.caremark.label',
    PAGE_TITLE: 'caremark.texts.title',
    PAGE_SUBTITLE: 'caremark.texts.subtitle',
    SUBMIT_BTN_TEXT: 'button.save',
    PHONE_FIELD_LABEL: 'caremark.texts.phoneLabel',
    PHONE_FIELD_HELPER: 'caremark.texts.phoneHelper',
    ENROLL_CAREMARK_TEXTS_OPTION_LEGEND: 'caremark.texts.enrollOptionLegend',
    ENROLL_CAREMARK_TEXTS_OPTION_HELPER: 'caremark.texts.enrollOptionHelper',
    CAREMARK_TEXT_OPTIONS_LEGEND: 'caremark.texts.optionsLegend',
    CAREMARK_TEXT_OPTIONS_HELPER: 'caremark.texts.optionsHelper',
  },
};

export const CALLS = {
  CAREMARK: {
    LABEL: 'calls.caremark.label',
    PAGE_TITLE: 'caremark.calls.title',
    PAGE_SUBTITLE: 'caremark.calls.subtitle',
    SUBMIT_BTN_TEXT: 'button.save',
    PHONE_FIELD_LABEL: 'caremark.calls.phoneLabel',
    PHONE_FIELD_HELPER: 'caremark.calls.phoneHelper',
    ENROLL_CAREMARK_CALLS_OPTION_LEGEND: 'caremark.calls.enrollOptionLegend',
    ENROLL_CAREMARK_CALLS_OPTION_HELPER: 'caremark.calls.enrollOptionHelper',
    CAREMARK_CALL_OPTIONS_LEGEND: 'caremark.calls.optionsLegend',
    CAREMARK_CALL_OPTIONS_HELPER: 'caremark.calls.optionsHelper',
  },
};

export const RX_EMAILS_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    desc: 'subscription.pharmacy.emails.enroll.desc',
  },
  {
    key: 'OUT',
    desc: 'subscription.pharmacy.emails.noEnroll.desc',
  },
];

export const RX_MAIL_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    desc: 'subscription.extracare.mail.enroll.desc',
  },
  {
    key: 'OUT',
    desc: 'subscription.extracare.mail.noEnroll.desc',
  },
];

export const SPECIALTY_EMAILS_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    label: 'subscription.specialty.emails.enroll.label',
    desc: 'subscription.specialty.emails.enroll.desc',
  },
  {
    key: 'OUT',
    label: 'subscription.specialty.emails.noEnroll.label',
    desc: 'subscription.specialty.emails.noEnroll.desc',
  },
];

export const CAREMARK_EMAILS_SUBSCRIPTION_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    label: 'subscription.caremark.emails.enroll.label',
    desc: 'subscription.caremark.emails.enroll.desc',
  },
  {
    key: 'OUT',
    label: 'subscription.caremark.emails.noEnroll.label',
    desc: 'subscription.caremark.emails.noEnroll.desc',
  },
];

export const ENROLL_CMK_TEXT_ALERTS_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    label: 'subscription.caremark.texts.enroll.label',
    desc: 'subscription.caremark.texts.enroll.desc',
  },
  {
    key: 'OUT',
    label: 'subscription.caremark.texts.noEnroll.label',
    desc: 'subscription.caremark.texts.noEnroll.desc',
  },
];

export const ENROLL_CMK_CALL_ALERTS_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    label: 'subscription.caremark.calls.enroll.label',
    desc: 'subscription.caremark.calls.enroll.desc',
  },
  {
    key: 'OUT',
    label: 'subscription.caremark.calls.noEnroll.label',
    desc: 'subscription.caremark.calls.noEnroll.desc',
  },
];

export const CMK_PHONE_CONFLICT = {
  HEADING: 'modal.cmkPhoneConflict.heading',
  DESC: 'modal.cmkPhoneConflict.desc',
  SUBMIT: 'modal.cmkPhoneConflict.submit',
  DECLINE: 'modal.cmkPhoneConflict.decline',
  CANCEL: 'button.cancel',
};

export const ProgramType: { [key: string]: string } = {
  '101': '101',
  '102': '102',
  '103': '103',
  '104': '104',
  '105': '105',
  '106': '106',
  '109': '109',
  '110': '110',
  '111': '111',
  '112': '112',
};

export const CMK_TEXT_ALERTS_OPTIONS_VALIDATIONS = {
  MAKE_A_SELECTION: 'validation.cmkTexts.makeSelection',
};

export const CMK_CALL_OPTIONS_VALIDATIONS = {
  MAKE_A_SELECTION: 'validation.cmkCalls.makeSelection',
};

export const CMK_EMAIL_OPTIONS_VALIDATIONS = {
  MAKE_A_SELECTION: 'validation.cmkEmails.makeSelection',
};

export const EMAIL_VALIDATION = {
  EMAIL_REQUIRED: 'validation.email.required',
  VALID_EMAIL_ID: 'validation.email.invalid',
  EMAIL_MAX_CHARS: 'validation.email.maxChars',
  MAKE_A_SELECTION: 'validation.makeSelection',
};

export const MAIL = {
  PAGE_TITLE: 'page.mail.title',
  LABEL: 'mail.extracare.label',
};

export const EXTRACARE_MAIL = {
  PAGE_TITLE: 'mail.extracare.title',
  PAGE_HELPER: 'mail.extracare.subtitle',
  PRIMARY_ADDRESS_LABEL: 'mail.extracare.primaryAddressLabel',
  EDIT: 'button.edit',
  PREF_OPTIONS_HEADING: 'mail.extracare.subscriptionHeading',
  PREF_OPTION_HELPER: 'mail.extracare.subscriptionHelper',
  INFO: 'mail.extracare.info',
  CUSTOMER_CARE_NUMBER: 'mail.extracare.customerCareNumber',
  CUSTOMER_CARE_NUMBER_LINK: 'mail.extracare.customerCareNumberLink',
};

export const EXTRACARE_EMAIL = {
  PAGE_TITLE: 'extracare.emails.title',
  PAGE_HELPER: 'extracare.emails.subtitle',
  EMAIL_FIELD_LABEL: 'extracare.emails.emailLabel',
  EMAIL_FIELD_HELPER: 'extracare.emails.emailHelper',
  EDIT: 'button.edit',
  PREF_OPTIONS_HEADING: 'extracare.emails.subscriptionHeading',
  PREF_OPTION_HELPER: 'extracare.emails.subscriptionHelper',
  INSTORE_RECEIPTS_HEADING: 'extracare.emails.instoreReceiptsHeading',
  INSTORE_RECEIPTS_HELPER: 'extracare.emails.instoreReceiptsHelper',
  INFO: 'extracare.emails.info',
  CUSTOMER_CARE_NUMBER: 'extracare.emails.customerCareNumber',
  CUSTOMER_CARE_NUMBER_LINK: 'extracare.emails.customerCareNumberLink',
};

export const EC_EMAIL_ALERTS_OPTIONS: SubscriptionOption[] = [
  {
    key: 'Y',
    desc: 'subscription.extracare.emails.enroll.desc',
  },
  {
    key: 'N',
    desc: 'subscription.extracare.emails.noEnroll.desc',
  },
];

export const INSTORE_RECEIPTS_OPTIONS: SubscriptionOption[] = [
  {
    key: 'D',
    desc: 'receipts.alwaysEmail.desc',
  },
  {
    key: 'B',
    desc: 'receipts.emailAndPrint.desc',
  },
  {
    key: 'P',
    desc: 'receipts.chooseAtCheckout.desc',
  },
];

export const EMAIL_ALERTS = {
  PAGE_TITLE: 'cvs.emails.title',
  PAGE_SUB_TITLE: 'cvs.emails.subtitle',
};

export const EMAIL_ALERTS_OPTIONS: SubscriptionOption[] = [
  {
    key: 'Y',
    desc: 'subscription.cvs.emails.enroll.desc',
  },
  {
    key: 'N',
    desc: 'subscription.cvs.emails.noEnroll.desc',
  },
];

export const H100_EMAIL_ALERTS_OPTIONS: SubscriptionOption[] = [
  {
    key: 'IN',
    desc: 'subscription.h100.emails.enroll.desc',
  },
  {
    key: 'OUT',
    desc: 'subscription.h100.emails.noEnroll.desc',
  },
];

export const ERROR_UPDATING_XLOB_PREFERENCES_TITLE = 'error.xlob.title';

export const ERROR_UPDATING_XLOB_PREFERENCES_BODY = 'error.xlob.body';

export const SPLTY_PROGRAMS = ['BD', 'DR', 'PS', 'RR', 'OS', 'IMM'];
